<template>
  <v-form ref="form"
          v-model="valid"
          lazy-validation
          data-vv-scope="storeTrain"
          @submit.prevent="validateBeforeSubmit('storeSchedule')">
    <v-layout row wrap>
      <v-flex xs12 md6>
        <label for="platform_number">Platform</label>
        <v-text-field  solo flat
            v-model="schedule.platform_number"
            v-validate="'required'"
            label="Platform"
            browser-autocomplete=off
            name="platform_number"
            :error-messages="errors.collect('storeSchedule.platform_number')">
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="platform_direction">Direction</label>
        <v-select
            solo flat
            v-model="schedule.platform_direction"
            :items="['LEFT', 'RIGHT', 'BOTH']"
            name="platform_direction"
            label="Direction"
            v-validate="'required'"
            :error-messages="errors.collect('storeSchedule.platform_direction')"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6>
        <label for="station">Station</label>
        <v-autocomplete
            solo flat
            v-model="schedule.station_id"
            :loading="loading.station"
            :items="stations"
            :search-input.sync="search.station"
            cache-items
            hide-no-data
            name="station"
            item-text="name"
            item-value="id"
            label="Station"
            v-validate="'required'"
            :error-messages="errors.collect('storeSchedule.station')"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
            ref="menu"
            v-model="timeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="schedule.time"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                v-model="schedule.time"
                label="Time"
                prepend-icon="access_time"
                readonly
                v-on="on"
                v-validate="'required'"
                :error-messages="errors.collect('storeSchedule.time')"
            ></v-text-field>
          </template>
          <v-time-picker
              v-if="timeMenu"
              v-model="schedule.time"
              full-width
              @click:minute="$refs.menu.save(schedule.time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <label for="station_order">Station Order</label>
        <v-text-field  solo flat
            v-model="schedule.station_order"
            v-validate="'required'"
            label="Station Order"
            browser-autocomplete=off
            name="station_order"
            :error-messages="errors.collect('storeSchedule.station_order')">
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-btn color="red" type="button" :loading="loading.submit" :disabled="loading.submit" @click="deleteSchedule">Delete</v-btn>
      </v-flex>
      <v-flex xs12 md6 text-align-right style="text-align: end">
        <v-btn color="primary" type="submit" :loading="loading.submit" :disabled="loading.submit" >Save</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "ScheduleForm",
  props: {
    scheduleData: {
      required: true
    }
  },
  watch: {
    'search.station': async function (val) {
      if (val) {
        this.stations = await this.getStationsList(val)
      }
    },
  },
  methods: {
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    storeSchedule() {
      this.loading.submit = true
      this.startLoading()
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/schedules`, this.schedule, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.$emit('success')
            }
          })
          .finally(() => {
            this.loading.submit = false
            this.stopLoading()
          })
    },
    getStationsList(search='', id = null) {
      return new Promise((resolve) => {
        axios.get(`${process.env.VUE_APP_API_URL}/api/v1/stations/search?search=${search}${id ? `&id=${id}` : ''}`, {headers: this.$headers})
            .then((response) => {
              if (response.data.status == 1) {
                resolve(response.data.data)
              }
            })
      })
    },
    async deleteSchedule() {
      // confirmation
      if (!confirm("Are you sure you want to delete this schedule?")) return;

      if (!this.schedule.id) return;

      this.loading.submit = true;
      this.startLoading();

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/v1/delete-schedules/${this.schedule.id}`,
          {},
          { headers: this.$headers }
        );

        if (response.data.status == 1) {
          this.$emit('success');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.submit = false;
        this.stopLoading();
      }
    },
  },
  data() {
    return {
      schedule: {
        platform: null
      },
      timeMenu: false,
      valid: false,
      stations: [],
      loading: {
        station: false,
        submit: false,
      },
      search: {
        station: null
      }
    }
  },
  async mounted() {
    this.stations = await this.getStationsList('', this.scheduleData.station_id)
    this.schedule = this.scheduleData
  }
}
</script>

<style scoped>

</style>
